import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorFactory } from './error-factory';
import { ErrorType } from '../../data-types/error-types';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private snackBar: MatSnackBar) {}

  handleNotification(error?: any, customMessage?: string, isSuccess: boolean = false) {
    let message: string;

    if (customMessage) {
      message = customMessage;
    }
    else if (error) {
      message = ErrorFactory.getError(error.status).getMessage();
    }
    else if (isSuccess) {
      message = 'Operation successful!';
    }
    else {
      message = 'An unknown error occurred.';
    }

    this.snackBar.open(message, 'OK', {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: [isSuccess ? 'success-snackbar' : 'error-snackbar']
    });
  }
}

